import { createContext, useContext } from 'react';

export const ConnectTicketsToCallContext = createContext({
  inConnectingTicketsToCall: false
});

export const useIsConnectingTicketsToCall = () =>
  useContext(ConnectTicketsToCallContext).inConnectingTicketsToCall;
